import HotWindows from './views/HotWindows.vue'
import routes from './routes'
export const HotWindowsModule = {
    views: { HotWindows },
    routes,
}
